import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRightIcon, DownloadIcon, ShieldCheckIcon } from 'lucide-react';
import { ebookImage, price } from '../data/content';
export function Hero() {
  return <section className="relative overflow-hidden bg-cream" data-id="element-68" data-mp="9k0g9cbeknrr">
      <div aria-hidden="true" className="absolute inset-x-0 top-0 h-px bg-teal/20" data-id="element-69" data-mp="9igvb8esxojn" />
      <div className="mx-auto grid max-w-6xl items-center gap-12 px-6 py-16 lg:grid-cols-[1.05fr_0.95fr] lg:gap-16 lg:py-24" data-id="element-70" data-mp="129h19owp12dy">
        <motion.div initial={{
        opacity: 0,
        y: 16
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.3,
        ease: [0.23, 1, 0.32, 1]
      }} data-id="element-71" data-mp="xa4gd9pdu5e0">
          <p className="text-sm font-semibold tracking-tight text-teal" data-id="element-72" data-mp="ncgk2fc4optq">
            Método Vientre Plano 21D · Guía digital
          </p>
          <h1 className="mt-4 font-display text-4xl font-semibold leading-[1.05] tracking-tight text-ink sm:text-5xl lg:text-6xl" data-id="element-73" data-mp="3d2bidl8y6rtf">
            Dile adiós a la hinchazón abdominal y recupera tu confianza en solo{' '}
            <span className="text-teal" data-id="element-74" data-mp="3j9ahhe4fas5o">21 días</span>.
          </h1>
          <h2 className="mt-6 max-w-prose text-lg leading-relaxed text-ink/70" data-id="element-75" data-mp="3o6kfhi5voc54">
            El método probado para desinflamar tu vientre, equilibrar tus
            hormonas y volver a usar tu ropa favorita sin sentirte apretada.
          </h2>

          <div className="mt-9 flex flex-col gap-4 sm:flex-row sm:items-center" data-id="element-76" data-mp="3eb90qzugz4xd">
            <a href="#precio" className="group inline-flex items-center justify-center gap-2 rounded-full bg-teal px-7 py-4 text-base font-semibold text-white shadow-sm transition-colors duration-150 ease-smooth hover:bg-teal-deep focus:outline-none focus-visible:ring-2 focus-visible:ring-teal-deep focus-visible:ring-offset-2 focus-visible:ring-offset-cream" data-id="element-77" data-mp="30gq6jbooj7q5">
              ¡Sí, quiero mi vientre plano ahora!
              <ArrowRightIcon className="h-4 w-4 transition-transform duration-150 ease-smooth group-hover:translate-x-0.5" aria-hidden="true" data-id="element-78" data-mp="2lla8ywow4tp0" />
            </a>
            <div className="text-sm leading-snug text-ink/60" data-id="element-79" data-mp="nb1j0zx5pjub">
              <span className="flex flex-wrap items-baseline gap-x-2 font-semibold text-ink" data-id="element-80" data-mp="ic85x8ls7uuo">
                {price.amount} {price.currency}
                <span className="text-ink/45 line-through" data-id="element-81" data-mp="de6munocvvj7">
                  {price.original}
                </span>
                <span className="rounded-full bg-gold-soft px-2 py-0.5 text-xs font-semibold text-gold" data-id="element-82" data-mp="1b0dte347zxy7">
                  −{price.discount}
                </span>
              </span>
              Acceso instantáneo después del pago.
            </div>
          </div>

          <ul className="mt-8 flex flex-wrap items-center gap-x-6 gap-y-2 text-sm text-ink/60" data-id="element-83" data-mp="x1w8se9m31ki">
            <li className="inline-flex items-center gap-2" data-id="element-84" data-mp="3lt774vhctzwd">
              <DownloadIcon className="h-4 w-4 text-teal" aria-hidden="true" data-id="element-85" data-mp="3lqm2jypo95ux" />
              Descarga inmediata en PDF
            </li>
            <li className="inline-flex items-center gap-2" data-id="element-86" data-mp="1x9uk28qzz9md">
              <ShieldCheckIcon className="h-4 w-4 text-teal" aria-hidden="true" data-id="element-87" data-mp="1x7hupaiwtwza" />
              Pago encriptado
            </li>
          </ul>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        scale: 0.96
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.3,
        delay: 0.08,
        ease: [0.23, 1, 0.32, 1]
      }} className="relative" data-id="element-88" data-mp="2b0pmp3awkuhi">
          <div className="overflow-hidden rounded-[2rem] bg-sand" data-id="element-89" data-mp="2ky4352wttj9t">
            <img src={ebookImage} alt="Tablet mostrando la portada de la guía Método Vientre Plano 21D sobre un mesón de mármol" className="h-full w-full object-cover" loading="eager" data-id="element-90" data-mp="2p0h65jk6v32w" />
          </div>
          <div className="absolute -bottom-5 left-6 rounded-2xl bg-white px-5 py-4 shadow-lg shadow-ink/5 ring-1 ring-ink/5" data-id="element-91" data-mp="uoak1pprb1vt">
            <p className="font-display text-2xl font-semibold text-ink" data-id="element-92" data-mp="4bdwfeqaa7o3">
              5 recursos
            </p>
            <p className="text-xs uppercase tracking-[0.14em] text-ink/50" data-id="element-93" data-mp="3vhxf1g2d31wy">
              en un solo bundle
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}